import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { store } from "./store";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "react-oidc-context";
import config from "config/Config";

const root = createRoot(document.getElementById("root") as HTMLElement);

const oidcConfig = {
  authority: config.OIDC_URL,
  client_id: "gradjevinar",
  redirect_uri: config.HOME_URL,
  onSigninCallback: () => {
    window.history.replaceState(
      {},
      document.title,
      window.location.pathname
    )
  }
}

root.render(
  <AuthProvider {...oidcConfig}>
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
